import { useForm } from "react-hook-form";
import ControlledForm from "~/shared/form/ControlledForm";
import FileInput from "~/shared/form/FileInput";
import FormButton from "~/shared/form/FormButton";
import FormResponse from "~/shared/form/FormResponse";
import SelectInput from "~/shared/form/SelectInput";
import TextInput from "~/shared/form/TextInput";

export default function UploadDocuments() {
    const documentTypes = ["Form I-9", "Form W-4", "Form G-4", "Driver's License", "Social Security Card", "Direct Deposit Authorization", "Banking Information"];
    const formHook = useForm();

    function onSubmit(data) {
        if (data.type === "Other") {
            data.type = data.typeOther;
            delete data.typeOther;
        }
    }

    return (
        <section>
            <ControlledForm hook={formHook} onSubmit={onSubmit} post="staff/documents/upload" resetOnSuccess={["file", "typeOther"]} success="Document successfully uploaded. You should receive an email confirming your document was received soon.">
                <div className="flex flex-col gap-3">
                    <SelectInput label="Document Type" id="type" options={[...documentTypes, "Other"]} placeholder="Select type" required />
                    {formHook.watch("type") === "Other" && <TextInput label="Document Type Description" id="typeOther" required />}
                    <FileInput id="file" extensions={["pdf"]} required />
                </div>
                <FormResponse />
                <FormButton legacy submit className="mt-4">Upload Document</FormButton>
            </ControlledForm>
        </section>
    );
}